import { createI18n } from "vue-i18n";
import enLocale from "@/locales/en.json";
import csLocale from "@/locales/cs.json";
import { en, cs } from "vuetify/locale";

export const i18n = createI18n({
    legacy: false,
    locale: "cs",
    fallbackLocale: "en",
    allowObjectMessages: true,
    messages: {
        en: {
            ...enLocale,
            $vuetify: {
                ...en,
            },
        },
        cs: {
            ...csLocale,
            $vuetify: {
                ...cs,
            },
        },
    },
});
